import React, { useEffect, useState } from 'react';
//import Swal from "sweetalert2"

import '../../styles/pacientesPendientes.css'

import { CSVLink } from "react-csv";
import { HiSave } from "react-icons/hi";

/**
 * Objetos
 */
//Importación de las funcionalidades del objeto de tipo unidadHospitalaria
//import { createCredential, updateMedicalPadron, createMedicalPadron } from '../../objects/asociado';

/**
 * Componentes
 */
//Componente que muestra el encabezado de una sección del site
import EncabezadoSeccion from './encabezadoSeccion';
//Componente que muestra al usuario que se esta procesando la información del servicio
import Loader from './loader';
//Componente que muestra la información de un paciente pendiente de alta medica
import PacientePendienteAlta from './pacienteCard';
//Componente que indica al usuario que no se obtuvo información con sus parámetros de búsqueda
import SinResultados from './sinResultados';

import CredentialTable from './credentalTable';

/**
 * Utilerías
 */
//Utilería que contiene funciones necesarias en la lógica del funcionamiento del sitio
import { compararInformación, quitarAcentos } from '../../utils/functions';

/**
 * Componente que contiene el listado de pacientes pendientes de salida de quirófano
 * @param {Object} param0 Recibe la información de sesión
 * @returns Component Devuelve el componente con los elementos y funcionalidad requeridos
 */
const PacientesPendientes = ({nomHospital,userLevel,uhList,name,isMostrarPacientes,setTotalQuirofano,setTotalRecuperacion,
    isLoader,pacientesList,padronList,setIsMostrarPacientes,setIsMostrarUsuarios,setIsMostrarRecuperacion,setAsociado,
    setDocumentoSeleccionado,setIsMostrarNuevo,setIsMostrarCredencial,setIsReadOnly,isReadOnly}) => {
    
    //Estado que indica la cantidad de pacientes con disponibles en el sistema
    const [cantidadPacientes,setCantidadPacientes] = useState(0)
    //Estado que indica si se hay pacientes que mostrar
    const [hayResultados, setHayResultados] = useState(false)
    //Estado que indica que se esta solicitando información al servicio
    //const [isLoader,setIsLoader] = useState(false)
    //Estado que indica si el estado anterior del paciente es recuperación
    const [isRecuperacionOrigen,setIsRecuperacionOrigen] = useState(false)
    //Estado que almacena la lista de contactos extras del paciente
    const [pacienteContactos,setPacienteContactos]=useState([])
    //Estado que indica si el usuario se encuentra en caso especial
    const [pacienteIsEspecial,setPacienteIsEspecial]=useState(false)
    //Estado que indica si el usuario se encuentra en sala de recuperación
    const [pacienteIsRecuperacion,setPacienteIsRecuperacion]=useState(false)
    //Estado que indica el paciente que ha sido seleccionado por el usuario
    const [pacienteSeleccionado,setPacienteSeleccionado] = useState(null)
    //Estado que indica la unidad hospitalaria a la que pertenece el paciente seleccionado por el usuario
    const [pacienteUnidadHospitalariaName,setPacienteUnidadHospitalariaName] = useState("")
    //Estado que indica si es posible para el usuario visualizar el teléfono del paciente
    const [pacienteTelefonoIsVisible,setPacienteTelefonoIsVisible]=useState(false)
    //Estado que indica si el paciente cuenta con contactos extras para notificación
    const [pacienteTieneContactos,setPacienteTieneContactos]=useState(false)
    //Estado que almacen el nombre de la unidad hospitalaria del paciente seleccionado
    const [pacienteUH,setPacienteUH]=useState("")
    //Estado que almacena los resultados de la búsqueda de pacientes según el parámetros requerido por el usuario
    const [pacientesAmostrarList,setPacientesAmostrarList] = useState([])
    //Estado que almacena los pacientes obtenidos desde la base de datos en una lista
    //const [pacientesList,setPacientesList] = useState([])
    //Estado que indica si se muestra la opción para limpiar la búsqueda
    const [seMuestra,setSeMuestra] = useState(true)
    //Estado que almacena el parametro de búsqueda para el muestreo de pacientes (si se encuentra vacio se consideran toda la lista de pacientes)
    const [valorBusqueda,setValorBusqueda] = useState("")
    //Estado que indica que si se requiere ver la vista de tipo tarjetas
    const [isTarjetasChecked,setIsTarjetasChecked] = useState(true)
    //Estado que almacena la vista seleccionada por el usuario
    const [vista,setVista] = useState("Tarjetas")
    const [uhSelected,setUhSelectd] = useState("General")
    const [isMostrarUnidad, setIsMostrarUnidad] = useState(false)
    const [today, setToday] = useState("")
    const [exportedList, setExportedList] = useState([])


    const headers = [
        { label: "Unidad Hospitalaria", key: "hospital"},
        { label: "Identificador", key: "identificador"},
        { label: "Nombre", key: "name"},
        { label: "Apellido", key: "lastname"},
        { label: "Registrado", key: "create"},
      ];

      const csvreport = {
        data: exportedList,
        headers: headers,
        filename: 'Medicos Credencializados '+uhSelected+' al '+today+'.csv',
    };

    const styleActive = { color: "white", margin: "5px auto 5px", height: "25px", fontSize:"3.0em"}
    
    useEffect(()=>{
        let hoy = new Date()
        setToday(hoy.getDate()+"-"+(hoy.getMonth()+1)+"-"+hoy.getFullYear())
    },[])

    useEffect(()=>{
        if(vista === "Lista"){
            setIsTarjetasChecked(false)
        }
        else{
            setIsTarjetasChecked(true)
        }
    },[vista])

    const onChangeVista = (vista) => {
        setVista(vista.target.value)
    };

    useEffect(()=>{
        if(valorBusqueda){
            setSeMuestra(true)
        }
        else{
            setSeMuestra(false)
        }
    },[valorBusqueda])

    useEffect(()=>{
        if(userLevel === "credencializacion" || userLevel === "lectura"){
            setIsMostrarUnidad(false)
            if(userLevel === "lectura"){
                setIsReadOnly(true)
            }
            else{
                setIsReadOnly(false)
            }
        }
        else{
            setIsMostrarUnidad(true)
            setIsReadOnly(false)
        }
    },[userLevel,setIsReadOnly])


    useEffect(()=>{
        let cantidadPacientesQuirofano = 0
        let cantidadPacientesRecuperacion = 0
        
        console.log(pacientesList)
        if(pacientesList.length > 0){//Verificar si existen pacientes pendites de alta
            if(valorBusqueda){//Se desea realizar búsqueda de un paciente específico
                let resultadoBusqueda = []
                pacientesList.forEach(//Se recorre la lista de pacientes
                    paciente => {
                        let completeName = paciente.name + " " + paciente.lastname
                        if(quitarAcentos(paciente.name).toUpperCase().includes(quitarAcentos(valorBusqueda).toUpperCase())
                        || quitarAcentos(paciente.specialty).toUpperCase().includes(quitarAcentos(valorBusqueda).toUpperCase())
                        || quitarAcentos(paciente.subspecialty).toUpperCase().includes(quitarAcentos(valorBusqueda).toUpperCase())
                        || quitarAcentos(paciente.hospital).toUpperCase().includes(quitarAcentos(valorBusqueda).toUpperCase())
                        || quitarAcentos(paciente.curp).toUpperCase().includes(quitarAcentos(valorBusqueda).toUpperCase())
                        || quitarAcentos(paciente.lastname).toUpperCase().includes(quitarAcentos(valorBusqueda).toUpperCase())
                        || quitarAcentos(completeName).toUpperCase().includes(quitarAcentos(valorBusqueda).toUpperCase())
                        || paciente.identificador.includes(valorBusqueda)){
                            if(userLevel === "superuser"){
                                if(uhSelected === "General"){
                                    resultadoBusqueda.push(paciente)
                                }
                                else{
                                    if(uhSelected === paciente.hospital){
                                        resultadoBusqueda.push(paciente)
                                    }
                                }
                            }
                            else{
                                if(nomHospital === paciente.hospital){
                                    resultadoBusqueda.push(paciente)
                                }
                                else{
                                    if(nomHospital === "MAC Aguascalientes Sur" || nomHospital === "MAC Aguascalientes Norte"){
                                        if(paciente.hospital === "MAC Aguascalientes Sur" || paciente.hospital === "MAC Aguascalientes Norte"){
                                            resultadoBusqueda.push(paciente)
                                        }
                                    }
                                }
                            }
                            
                        }
                    }
                )

                if(resultadoBusqueda.length > 0){//Se encontraron resultados a la búsqueda deseada
                    setHayResultados(true)
                    //Ordenar los resultados por un valor específico
                    resultadoBusqueda.sort(compararInformación('name'))
                    setCantidadPacientes(resultadoBusqueda.length)
                }
                else{//La búsqueda no obtuvo ningún paciente como resultado
                    setHayResultados(false)
                    setCantidadPacientes(0)
                }
                console.log(resultadoBusqueda)
                setExportedList(resultadoBusqueda)
                setPacientesAmostrarList(resultadoBusqueda)
            }
            else{//Se muestran todos los pacientes disponibles
                pacientesList.sort(compararInformación('name'))
                let pacientesValidos = 0
                let pacientesAExportar = []
                pacientesList.forEach(
                    paciente => {
                        if(userLevel === "superuser"){
                            if(uhSelected === "General"){
                                pacientesValidos++
                                pacientesAExportar.push(paciente)
                                if(paciente.active){
                                    cantidadPacientesQuirofano++
                                }
                                else{
                                    cantidadPacientesRecuperacion++
                                }
                            }
                            else{
                                if(uhSelected === paciente.hospital){
                                    pacientesValidos++
                                    pacientesAExportar.push(paciente)
                                    if(paciente.active){
                                        cantidadPacientesQuirofano++
                                    }
                                    else{
                                        cantidadPacientesRecuperacion++
                                    }
                                }
                            }
                        }
                        else{
                            if(nomHospital === paciente.hospital){
                                pacientesValidos++
                                pacientesAExportar.push(paciente)
                                if(paciente.active){
                                    cantidadPacientesQuirofano++
                                }
                                else{
                                    cantidadPacientesRecuperacion++
                                }
                            }
                            else{
                                if(nomHospital === "MAC Aguascalientes Sur" || nomHospital === "MAC Aguascalientes Norte"){
                                    if(paciente.hospital === "MAC Aguascalientes Sur" || paciente.hospital === "MAC Aguascalientes Norte"){
                                        pacientesValidos++
                                        pacientesAExportar.push(paciente)
                                    }
                                }
                            }
                        }
                    }
                )

                if(pacientesValidos > 0){//Se verifica si existen pacientes que pertenezcan a la unidad hospitalaria requerida
                    if(isMostrarPacientes){
                        setCantidadPacientes(cantidadPacientesQuirofano)
                        if(cantidadPacientesQuirofano > 0){
                            setHayResultados(true)
                        }
                        else{
                            setHayResultados(false)
                        }
                    }
                    else{
                        setCantidadPacientes(cantidadPacientesRecuperacion)
                        if(cantidadPacientesRecuperacion > 0){
                            setHayResultados(true)
                        }
                        else{
                            setHayResultados(false)
                        }
                    }
                    //setCantidadPacientes(pacientesValidos)
                    setTotalQuirofano(cantidadPacientesQuirofano)
                    setTotalRecuperacion(cantidadPacientesRecuperacion)
                    console.log(pacientesList)
                    setExportedList(pacientesAExportar)
                    setPacientesAmostrarList(pacientesList)
                    
                }
                else{//No se encientraron pacientes pertenecientes a la unidad hospitalaria
                    setPacientesAmostrarList([])
                    setHayResultados(false)
                    setCantidadPacientes(0)
                    setTotalQuirofano(0)
                    setTotalRecuperacion(0)
                }
            }
        }
        else{//No hay pacientes por mostrar
            setPacientesAmostrarList([])
            setHayResultados(false)
        }

    },[pacientesList,valorBusqueda,nomHospital,userLevel,uhList,isMostrarPacientes,setTotalQuirofano,setTotalRecuperacion,uhSelected])


    /**
     * Función que atrapa el evento de limpiar la búsqueda
     * @returns Devuelve el estado del objeto
     */
    const handleCancelarClick = () => (event) => {
        event.preventDefault()
        setValorBusqueda("")
    }


    const handleAgregar = () => (event) => {
        setIsMostrarNuevo(true)
    }

    const handleChange = (e) => {
        setUhSelectd(e.target.value)
      };

    return(
        <>
        <section className='seccion_pacientes_pendientes'>
            <div id="cuerpoEncabezado" className='cuerpoEncabezado'>
                {
                    !isReadOnly
                        ?
                            <button className="btn-flotante" title="Agregar credencial" alt="Agregar" onClick={handleAgregar()}>+ Nuevo Asociado</button>
                        :
                            null
                }
                
                {
                    isMostrarPacientes ? <EncabezadoSeccion tituloInicial={"Médicos asociados "} tituloFinal={"activos disponibles:"} imgSource={"https://hospitalesmac.com/img/icono_16.png"} cantidad={cantidadPacientes}/>
                    : <EncabezadoSeccion tituloInicial={"Médicos asociados "} tituloFinal={"inactivos disponibles:"} imgSource={"https://hospitalesmac.com/img/icono_16.png"} cantidad={cantidadPacientes}/>
                }
                                    
                <div className='firstfiltercont'>
                    <div className='ftconfliter'>
                        <div className="text-container">
                            <input type="text" 
                                name="valorBusqueda" 
                                value={valorBusqueda} 
                                className='inputbuscardirectorio' 
                                placeholder="Búsqueda abierta aquí..."
                                onChange={(event) => setValorBusqueda(event.target.value)}
                            />
                            {
                                seMuestra ? <span className='clearBtn' onClick={handleCancelarClick()}>X</span>
                                : null
                            } 
                        </div>
                        {
                            isMostrarUnidad
                                ?
                                    <div className="contenedor" id="contenedorHospital">
                                        {/* <div className="contenedorEncabezado">
                                            Unidad Hospitalaria
                                        </div> */}
                                        <div className='unidad'>Unidad Hospitalaria</div>
                                        <select onChange={(e) => handleChange(e)}> 
                                            <option value={"General"}>{"General"}</option>
                                            {
                                                uhList.map(uh =>
                                                    <option value={uh.hospital}>{uh.hospital}</option>
                                                )
                                            }
                                        </select>
                                    </div>
                                :
                                    null
                        }
                        <div className="datos">
                                <input type="radio" value="Tarjetas" name="vista" checked={isTarjetasChecked} onChange={onChangeVista}/> Tarjetas
                                <input type="radio" value="Lista" name="vista" checked={!isTarjetasChecked} onChange={onChangeVista}/> Listado
                        </div>
                    </div>
                </div>
            </div>
            <div className='itemservespCont'>
                {
                    isLoader ?
                        <Loader/>
                    :
                        hayResultados ?
                            isTarjetasChecked
                                ?
                                    pacientesAmostrarList.map(paciente => 
                                        <PacientePendienteAlta key={paciente.id} paciente={paciente} userLevel={userLevel} nomHospitalUser={nomHospital} uhList={uhList} setPacienteSeleccionado={setPacienteSeleccionado} 
                                        pacienteSeleccionado={pacienteSeleccionado} pacienteIsRecuperacion={pacienteIsRecuperacion} setPacienteIsRecuperacion={setPacienteIsRecuperacion}
                                        pacienteTelefonoIsVisible={pacienteTelefonoIsVisible} setPacienteTelefonoIsVisible={setPacienteTelefonoIsVisible}
                                        pacienteTieneContactos={pacienteTieneContactos} setPacienteTieneContactos={setPacienteTieneContactos}
                                        pacienteContactos={pacienteContactos} setPacienteContactos={setPacienteContactos}
                                        name={name} pacienteUH={pacienteUH} setPacienteUH={setPacienteUH}
                                        pacienteIsEspecial={pacienteIsEspecial} setPacienteIsEspecial={setPacienteIsEspecial}
                                        isRecuperacionOrigen={isRecuperacionOrigen} setIsRecuperacionOrigen={setIsRecuperacionOrigen}
                                        isMostrarPacientes={isMostrarPacientes}
                                        pacienteUnidadHospitalariaName={pacienteUnidadHospitalariaName} setPacienteUnidadHospitalariaName={setPacienteUnidadHospitalariaName}
                                        setIsMostrarUsuarios={setIsMostrarUsuarios}
                                        setAsociado={setAsociado}
                                        setDocumentoSeleccionado={setDocumentoSeleccionado}
                                        setIsMostrarCredencial={setIsMostrarCredencial}
                                        uhSelected={uhSelected}
                                        isReadOnly={isReadOnly}
                                        />
                                    )
                                :
                                    <CredentialTable medicos={pacientesAmostrarList} setAsociado={setAsociado} 
                                    setDocumentoSeleccionado={setDocumentoSeleccionado} setIsMostrarUsuarios={setIsMostrarUsuarios}
                                    uhList={uhList} setIsMostrarCredencial={setIsMostrarCredencial} isMostrarPacientes={isMostrarPacientes}
                                    nomHospitalUser={nomHospital} userLevel={userLevel} uhSelected={uhSelected} isReadOnly={isReadOnly}/>
                        :
                            <SinResultados/>
                }
                <CSVLink {...csvreport} className="btn-flotanteExportMedicos" title="Exportar a CSV" alt="Exportar"><HiSave style={styleActive}/></CSVLink>
            </div>
        </section>
        </>
        )
}

export default PacientesPendientes;